module.exports = __webpack_public_path__ + "static/media/default.9c0bc3ae.svg";